/**
 * @fileoverview Exit scroll depth resolution for page_engagement events.
 * @description Pure helper so SPA route cleanup can use scrollability captured
 * while the route was active instead of re-reading the successor page DOM.
 *
 * @module lib/site-intelligence/page-engagement-exit
 */

/**
 * Resolves scroll depth for a page exit using frozen route-scoped state.
 *
 * @param {Object} options - Exit measurements frozen at route scope.
 * @param {boolean} options.pageWasScrollable - Whether the exited page had scroll overflow.
 * @param {number} options.maxScrollPct - Max scroll depth observed on that page [0–100].
 * @returns {{ pct: number; synthetic: boolean }} Depth and synthetic flag for GA4.
 */
export function resolvePageExitScrollDepth(options: {
  pageWasScrollable: boolean
  maxScrollPct: number
}): { pct: number; synthetic: boolean } {
  if (!options.pageWasScrollable) {
    return { pct: 100, synthetic: true }
  }
  return { pct: options.maxScrollPct, synthetic: false }
}
